import React, { FC } from 'react';
import {Icon} from './Icon';
import { isMobile } from "react-device-detect";

interface ProductTagProps {
  name: string;
  margin?: boolean;
  imageIn?: boolean;
}

export const ProductTag: FC<ProductTagProps> = ({ name, margin = false, imageIn = false }) => {
  return (
    <>
      <div className={`outlined-brand-1 text-10 md:text-12 font-semibold px-3 py-1 w-max uppercase ${margin && 'mr-0.5 mb-0.5'} ${imageIn && 'hidden'}`}>
        {name}
      </div>
        {imageIn &&
        <div className={`absolute top-0`}>
            <Icon.Extra className={`${isMobile ?  'wh-12': 'wh-16'}`} />
        </div>
        }
    </>
  );
};
